import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { loadThree, createStlScene } from '../../lib/stlRenderer';

export default class StlViewer extends Component {
    constructor(props) {
        super(props);
        this.state = { status: 'loading' }; // 'loading' | 'ready' | 'error'
        this.canvasRef = null;
        this.scene = null;
        this.unmounted = false;
    }

    componentDidMount() {
        this.init();
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.cleanup();
    }

    setCanvasRef = el => {
        this.canvasRef = el;
    };

    async init() {
        const {
            src, color, background, interactive = true, onSnapshot, onError,
        } = this.props;
        try {
            if (typeof window === 'undefined' || !window.WebGLRenderingContext) {
                throw new Error('WebGL is not supported');
            }
            const { THREE, STLLoader, OrbitControls } = await loadThree();
            const response = await fetch(src);
            if (!response.ok) {
                throw new Error(`Failed to load model: ${response.status}`);
            }
            const arrayBuffer = await response.arrayBuffer();
            if (this.unmounted || !this.canvasRef) {
                return;
            }
            const rect = this.canvasRef.getBoundingClientRect();
            const width = Math.max(1, Math.floor(rect.width) || 400);
            const height = Math.max(1, Math.floor(rect.height) || 400);
            this.scene = createStlScene({
                THREE,
                STLLoader,
                OrbitControls: interactive ? OrbitControls : null,
                arrayBuffer,
                canvas: this.canvasRef,
                width,
                height,
                color,
                background,
                interactive,
            });
            this.setState({ status: 'ready' });
            if (typeof onSnapshot === 'function'
                && this.scene.renderer
                && this.scene.renderer.domElement
                && this.scene.renderer.domElement.toBlob) {
                this.scene.renderer.domElement.toBlob(blob => {
                    if (blob) {
                        onSnapshot(blob);
                    }
                }, 'image/png');
            }
        } catch (err) {
            if (!this.unmounted) {
                this.setState({ status: 'error' });
            }
            if (typeof onError === 'function') {
                onError(err);
            }
        }
    }

    cleanup() {
        if (this.scene && typeof this.scene.dispose === 'function') {
            this.scene.dispose();
        }
        this.scene = null;
    }

    render(props, { status }) {
        const { class: className = '', style = 'width:100%; height:50vh;' } = props;
        return (
            <div class={`stl-viewer position-relative bg-body-secondary rounded ${className}`} style={style}>
                <canvas ref={this.setCanvasRef} class='w-100 h-100' style='display:block; touch-action:none;' />
                {status === 'loading' && (
                    <div class='position-absolute top-50 start-50 translate-middle text-body-secondary'>
                        <Text id='product.3d-loading'>Loading 3D preview…</Text>
                    </div>
                )}
                {status === 'error' && (
                    <div class='position-absolute top-50 start-50 translate-middle text-body-secondary text-center'>
                        <i class='fa-duotone fa-cube fa-2x d-block mb-2' />
                        <Text id='product.3d-unavailable'>3D preview unavailable</Text>
                    </div>
                )}
            </div>
        );
    }
}
